import React from 'react';

class FooterComponent extends React.Component {
  render() {
    return (
      <footer>
        <p>© Copyright 2017  <a href="https://www.ideacommercesolutions.pl" target="_blank">IDEA commerce solutions</a> Wszelkie prawa zastrzeżone.</p>
        <p className="pull-right">Powered by <a href="https://www.ideaerp.pl/" target="_blank">IDEAerp</a>.</p>
      </footer>
    );
  }
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/Footer.js